import { REQUEST_MONITORS, RECEIVE_MONITORS, IMonitorState, MonitorTypes } from "./types";

const initialState: IMonitorState = { monitorData: [], isLoading: false };

export function monitorReducer(state = initialState, action: MonitorTypes): IMonitorState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_MONITORS:
            return {
                isLoading: true,
                monitorData: state.monitorData,
            };
        case RECEIVE_MONITORS:
            return {
                isLoading: false,
                monitorData: action.monitorData,
            };
        default:
            return state;
    }
}
